import { render, staticRenderFns } from "./PatientVerificationDetail.vue?vue&type=template&id=7e2e5f9c"
import script from "./PatientVerificationDetail.vue?vue&type=script&lang=js"
export * from "./PatientVerificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports